<template>
  <div
    :class="[$style.Quantity, { [$style['Quantity--disabled']]: disabled }]"
    class="flex"
  >
    <button
      :class="[
        $style['Quantity__manipulator'],
        $style['Quantity__manipulator--decrement'],
        {
          [$style['Quantity__manipulator--disabled']]: quantity <= 0
        }
      ]"
      @click="dec"
    >
      <span class="font-semibold">-</span>
    </button>
    <text-input
      v-model.number="q"
      type="number"
      placeholder="0"
      :max="max"
      :min="min"
      :class="$style['Quantity__field']"
      :step="1"
      @keyup.native="checkInput"
    />
    <button
      :class="[
        $style['Quantity__manipulator'],
        $style['Quantity__manipulator--increment'],
        {
          [$style['Quantity__manipulator--error']]: error
        }
      ]"
      @click="add"
    >
      <span class="font-semibold">+</span>
    </button>
  </div>
</template>

<script>
import TextInput from './input/TextInput';

export default {
  name: 'Quantity',
  components: { TextInput },
  props: {
    add: {
      type: Function,
      required: true
    },
    dec: {
      type: Function,
      required: true
    },
    change: {
      type: Function,
      required: true
    },
    quantity: {
      type: Number,
      required: false,
      default: null
    },
    error: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    min: {
      type: Number,
      default: 0,
      required: false
    },
    max: {
      type: Number,
      default: 100,
      required: false
    }
  },
  data() {
    return {
      q: this.quantity
    };
  },
  watch: {
    quantity(newVal) {
      this.checkIfZero(newVal);
    }
  },
  mounted() {
    this.checkIfZero(this.quantity);
  },
  methods: {
    checkIfZero(newVal) {
      if (0 === newVal) {
        newVal = '';
      }
      this.q = newVal;
    },
    checkInput() {
      let newVal = parseInt(this.q, 10);
      this.checkIfZero(newVal);
      this.change(this.q);
    }
  }
};
</script>
<style lang="scss" src="../scss/components/Quantity.scss" module></style>
